import { Link } from "react-router-dom";
import { ICardResponse } from "../../../core/models";
import "./highlightscard.scss";

export interface IHighligtsCardProps {
  card: ICardResponse;
}

const HighlightsCard = ({ card }: IHighligtsCardProps) => {
  const pushEventForCardClick = () => {
    if (window && (window as any)["ReactNativeWebView"]) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "eventLogForCountly",
          eventName: "Haberler Tıklama",
          eventSegment: { haberAdi: card?.title, yol: 'Son Haberler' },
          actionType: "event",
        })
      );
    }
  };

  return (
    <Link
      to={{
        pathname: card.detailUrl,
      }}
      className="highlights-card"
      onClick={pushEventForCardClick}
    >
      <img
        src={card.listImage?.src}
        width={164}
        height={100}
        alt={card.listImage?.alt}
        style={{ height: "auto", width: "164px" }}
      />
      <div className="highlights-card__text">
        <span className="badge">{card.type}</span>
        <span className="title">
          <strong>{card.title}</strong>
        </span>
        <div className="date-container">
          <span className="date">{card.dateAreaFormatted}</span>
          <span className="time ">{card.readTime}</span>
          <img src={"/icons/clock.svg"} width={16} height={16} alt="clock" />
        </div>
      </div>
    </Link>
  );
};

export default HighlightsCard;
